<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" v-loading="loading" :visible.sync="visible" :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                   <el-form-item   prop="roleType" label="展示对象">
                        <el-select v-model="form.roleType" clearable placeholder="请选择" style="width:300px;">
                            <el-option
                                v-for="item in roleTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="moduleTitle" label="功能名称">
                        <el-select v-model="form.moduleTitle" clearable placeholder="请选择" style="width:300px;">
                            <el-option
                                v-for="item in moduleTitles"
                                :key="item.label"
                                :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item   prop="moduleTitleByname" label="功能别名">
                        <el-input v-model="form.moduleTitleByname" maxlength="50" style="width:300px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="moduleTwoTitle" label="功能描述">
                        <el-input v-model="form.moduleTwoTitle" maxlength="100" style="width:300px;"></el-input>
                    </el-form-item>

                    <!-- <el-form-item   prop="moduleIcon" label="LOGO图标">
                        <el-select v-model="form.moduleIcon" clearable placeholder="请选择" style="width:300px;">
                            <el-option
                                v-for="item in moduleIcons"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item> -->

                    <el-form-item   prop="jumpUrl" label="跳转URL">
                        <el-input v-model="form.jumpUrl" maxlength="500" style="width:300px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="evaluateId" label="绑定五育指标">
                        <el-input placeholder="请选择指标" :readonly="true" v-model="form.evaluateTitle" class="input-with-select" style="width:300px;">
                            <el-button slot="append" icon="el-icon-search" @click="getEvaluate()"></el-button>
                        </el-input>
                    </el-form-item>
                    
                     <el-form-item prop="showUserRoster" label="拥有权限者">
                        <el-button @click="getMoreUser(1)">{{form.showUserRosterLabel}}</el-button>
                    </el-form-item>

                    <el-form-item prop="notshowUserRoster" label="无权限者">
                        <el-button @click="getMoreUser2(1)">{{form.notshowUserRosterLabel}}</el-button>
                    </el-form-item>

                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="20" type="number" style="width:300px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框多人 -->
        <div v-if="userTransferMoreVisible">
            <userTransferMore ref="userTransferMore"></userTransferMore>
        </div>
        <!-- 五育指标弹出框 -->
        <div v-if="evaluateIndicatorsDefineVisible">
            <evaluateIndicatorsDefine ref="evaluateIndicatorsDefine"></evaluateIndicatorsDefine>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 
    import userTransferMore from '../../sys/user/UserTransfer.vue';
    import { Base64 } from 'js-base64';
    import evaluateIndicatorsDefine from '../classset/EvaluateIndicatorsDefine.vue';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                userTransferMoreVisible:false,
                evaluateIndicatorsDefineVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    roleType:"",
                    moduleTitle:"",
                    moduleTitleByname:"",
                    moduleTwoTitle:"",
                    // moduleIcon:"",
                    // moduleIcon2:"",
                    jumpUrl:"",
                    // homeShowStatus:"",
                    moduleStatus:"",
                    showUserRoster:[],
                    showUserRosterLabel:"请选择",
                    notshowUserRoster:[],
                    notshowUserRosterLabel:"请选择",
                    orderNum:"",
                    evaluateId:"",
                    evaluateTitle:"",
                },
                roleTypes:[{
                    value: 0,
                    label: '全部'
                },{
                    value: 1,
                    label: '家长'
                }, {
                    value: 2,
                    label: '教职'
                }],
                moduleTitles:[],
                selectUserType:"",
                moduleIcons:[],
                rules: {
                    roleType: [
                        { required: true, message: '请输入展示对象', trigger: 'blur' }
                    ],
                    moduleTitle: [
                        { required: true, message: '请输入标题', trigger: 'blur' }
                    ],
                    moduleTwoTitle: [
                        { required: true, message: '请输入模块描述', trigger: 'blur' }
                    ],
                    // moduleIcon: [
                    //     { required: true, message: '请选择功能LOGO', trigger: 'blur' }
                    // ],
                    jumpUrl: [
                        { required: true, message: '请输入跳转地址', trigger: 'blur' }
                    ],
                    moduleStatus: [
                        { required: true, message: '请选择模块状态', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
           userTransferMore,
           evaluateIndicatorsDefine
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(data, moduleConfigNames){
                this.visible=true
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                // 初始值
                this.form.id=data.id
                this.form.deptId=data.deptId
                this.form.roleType=data.roleType
                this.form.moduleTitle=data.moduleTitle
                this.form.moduleTitleByname = (data.moduleTitleByname==null?'':data.moduleTitleByname)
                this.form.moduleTwoTitle=data.moduleTwoTitle
                // this.form.moduleIcon=data.moduleIcon
                // this.form.moduleIcon2=data.moduleIcon2
                this.form.jumpUrl=data.jumpUrl
                this.form.moduleStatus=data.moduleStatus
                if(this.$util.isNotEmpty(data.showUserRoster)){
                    this.form.showUserRoster=data.showUserRoster.split(',')
                    this.form.showUserRosterLabel=data.showUserRoster.split(',').length+"人"
                }else{
                    this.form.showUserRosterLabel="请选择"
                    this.form.showUserRoster=[]
                }
                if(this.$util.isNotEmpty(data.notshowUserRoster)){
                    this.form.notshowUserRoster=data.notshowUserRoster.split(',')
                    this.form.notshowUserRosterLabel=data.notshowUserRoster.split(',').length+"人"
                }else{
                    this.form.notshowUserRosterLabel="请选择"
                    this.form.notshowUserRoster=[]
                }
                this.form.orderNum=data.orderNum
                this.form.evaluateId=(data.commonId==null?"":data.commonId)
                this.form.evaluateTitle=data.commonName

                // 初始机构
                this.moduleTitles = []
                this.getModuleIcon()

                
            },
            getModuleIcon(){
                //部门管理
                let url  = this.listDictUrl;
                let data = {
                    name:"MODULE_TYPE_KEY",
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        let titles = res.data.list
                        for(let i=0;i<titles.length;i++){
                            let tempTitleObj = {}
                            tempTitleObj.label = titles[i].name
                            tempTitleObj.value = titles[i].value
                            this.moduleTitles.push(tempTitleObj)
                        }

                        // 列表已存在的模块，过滤列表模块
                        for(let i=0; i<this.moduleTitles.length; i++){
                            if(moduleConfigNames.indexOf(this.moduleTitles[i].value) >-1 
                                &&  this.moduleTitles[i].value.indexOf(data.moduleTitle) == -1){
                                this.moduleTitles.splice(i, 1)
                                --i
                            }
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        // 获取Logo
                        let moduleIcon=""
                        for(let i=0;i<this.moduleTitles.length;i++){
                            let moduleTitle = this.moduleTitles[i].label
                            if(this.form.moduleTitle === moduleTitle){
                                moduleIcon = this.moduleTitles[i].value
                                break
                            }
                        }
                        
                        let url= this.moduleConfigUpdateUrl;
                        this.loading=true;
                        let data = {
                            id:this.form.id,
                            roleType:this.form.roleType,
                            moduleTitle:this.form.moduleTitle,
                            moduleTitleByname:this.form.moduleTitleByname,
                            moduleTwoTitle:this.form.moduleTwoTitle,
                            moduleIcon:Base64.encode(moduleIcon),
                            // moduleIcon2:Base64.encode(this.form.moduleIcon2),
                            jumpUrl:this.form.jumpUrl,
                            evaluateId:this.form.evaluateId,
                            moduleStatus:this.form.moduleStatus,
                            showUserRoster:this.form.showUserRoster.join(','),
                            notshowUserRoster:this.form.notshowUserRoster.join(','),
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            },
            getMoreUser(type){ // 拥有权限者
                this.selectUserType=1;
                this.userTransferMoreVisible=true;
                this.$nextTick(() => {
                    // console.log("角色："+this.form.roleType);
                    if(this.form.roleType == 0){
                        // 全部
                        this.$refs['userTransferMore'].init('',this.form.showUserRoster,2,this.form.deptId);
                    }else if(this.form.roleType == 1){
                        // 学生
                        this.$refs['userTransferMore'].init(1,this.form.showUserRoster,2,this.form.deptId);
                    }else if(this.form.roleType == 2){
                        // 教职
                        this.$refs['userTransferMore'].init(2,this.form.showUserRoster,2,this.form.deptId);
                    }else{
                         this.$commonFn.showTip("请选择展示对象，然后再指定显示人员",3);
                    }
                })
            },
            getMoreUser2(type){ // 没有权限者
                this.selectUserType=2;
                this.userTransferMoreVisible=true;
                this.$nextTick(() => {
                    // console.log("角色："+this.form.roleType);
                    if(this.form.roleType == 0){
                        // 全部
                        this.$refs['userTransferMore'].init('',this.form.notshowUserRoster,2,this.form.deptId);
                    }else if(this.form.roleType == 1){
                        // 学生
                        this.$refs['userTransferMore'].init(1,this.form.notshowUserRoster,2,this.form.deptId);
                    }else if(this.form.roleType == 2){
                        // 教职
                        this.$refs['userTransferMore'].init(2,this.form.notshowUserRoster,2,this.form.deptId);
                    }else{
                         this.$commonFn.showTip("请选择展示对象，然后再指定显示人员",3);
                    }
                })
            },
            setUser(data,name){
                if(this.selectUserType == 1){
                    if(data.length == 0){
                        this.form.showUserRosterLabel="请选择";
                    }else{
                        this.form.showUserRosterLabel=data.length+"人";
                    }
                    this.form.showUserRoster=data;
                }else{
                    if(data.length == 0){
                        this.form.notshowUserRosterLabel="请选择";
                    }else{
                        this.form.notshowUserRosterLabel=data.length+"人";
                    }
                    this.form.notshowUserRoster=data;
                }
            },
            getEvaluate(){
                this.evaluateIndicatorsDefineVisible=true;
                this.$nextTick(() => { 
                    this.$refs['evaluateIndicatorsDefine'].init(this.form.deptId);
                })
            },
            setEvaluate(key,label){
                this.form.evaluateId = key;
                this.form.evaluateTitle = label;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/moduleconfig/Update.vue